export default __webpack_public_path__ + "static/media/img6.04ccec20.jpg";